import {
  Button,
  Icon,
  Pill,
  TimelinePanel,
  useTimelinePanelStore,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React from "react";
import styles from "./WorkerDetailTimelinePanelTrigger.module.scss";

const cx = classNames.bind(styles);

type WorkerDetailTimelinePanelTriggerProps = {
  targetDrawer: string;
  versionsCount: number;
};

export const WorkerDetailTimelinePanelTrigger = ({
  targetDrawer,
  versionsCount,
}: WorkerDetailTimelinePanelTriggerProps) => {
  const { isOpen, targetDrawer: currentDrawer } = useTimelinePanelStore();
  const isActive = isOpen && currentDrawer === targetDrawer;

  return (
    <TimelinePanel.Trigger targetDrawer={targetDrawer}>
      {({ onClick }) => (
        <Button
          className={cx("timeline-panel-button", {
            "timeline-panel-button__active": isActive,
          })}
          variant="outline"
          slotLeft={
            <Icon
              variant="clock-counter-clockwise"
              size={19}
            />
          }
          slotRight={<Pill variant="default">{versionsCount}</Pill>}
          onClick={() => {
            onClick?.();
          }}
        >
          Versions
        </Button>
      )}
    </TimelinePanel.Trigger>
  );
};
